import { gql } from '@apollo/client';

export const GET_STUDENTS_TRANSACTIONS_LIST = gql`
  query SkWeb_TransactionList(
    $schoolId: ID!
    $classroomId: ID
    $userId: ID
    $date: Date
    $page: Int
    $pageSize: Int
  ) {
    transactionList(
      schoolId: $schoolId
      classroomId: $classroomId
      userId: $userId
      date: $date
      page: $page
      pageSize: $pageSize
    ) {
      data {
        id
        amount
        createdAt
        updatedAt
        remark
        owner {
          id
          name
        }
        creator {
          id
          name
        }
      }
      totalCount
    }
  }
`;
